<template>
	<div ref="container" class="position-relative d-flex flex-column h-100">
		<loading ref="loading"></loading>
		<header class="list-header" style="z-index: 100;">
			<h1 class="h2 p-2 text-center">{{ autobrand(title) + getItemCount() | capitalise}}</h1>
		</header>

		<list-filter :key='event' ref="listFilter" :modalid='modalid'></list-filter>

		<div class="errors">
            <template v-for="(error, key) in errors">
                <p class="alert alert-warning" v-for="message in error">{{message}}</p>
            </template>
        </div>
		<div class='flex-grow-1-scroll h-100'>
			<div class="p-2" v-show='items.data instanceof Array && items.data.length === 0'>No items found.</div>
			<component v-bind:is='displayelement'></component>
            <div class="text-center">
                <button v-if='environment_settings.MIX_ENABLE_ARCHIVE && hasarchive && !archive && items.next_page_url == null' type='button' class='btn btn-primary' v-on:click='enableArchive()'>
                    {{ autobrand('translations.continue_search_in_archive') }}
                </button>
            </div>
		</div>
		<footer class='list-footer open'>
			<button v-if='canCreate()' class="btn btn-circle mr-2" v-on:click="openCreate">+</button>
			<!-- <pagination :limit="0" ref="paginator" :data="items" v-on:pagination-change-page="getResults" ></pagination> -->
			<paginator  :pagination="items"
                 @paginate="getResults()"
				 :offset="1"
                 :simple='true'></paginator>
		</footer>
	</div>
</div>

</template>

<script>
	export default {
		props: {
			'route': {},
			'event': {},
			'model': {},
			'path': {},
			'title': {},
			'displayelement': {},
			'modalid': {},
			'subroute': {
				default: 0
            },
            'hasarchive': {
                default: 0
            }
		},
		data: function(){
			return {
				items: {},
				filterFields: {},
				page: 1,
				errors: [],
				notification: "",
				test_state: true,
				quickFilters: {
					//assigned: false
                },
                stale: false,
                archive: false,
			};
		},
		computed: {
		},
		watch: {
			route: function (val) {
		 		this.initData();
		    },
    		"$root.connected" (newState, oldState) {
                if(newState == true && oldState == false) {
                    if(this.appActive()) {
                        this.getResults();
                    }
                    else {
                        this.stale = true;
                    }
                }
            },
            "$root.visibility" (newState, oldState) {
                if(newState == "visible" && this.stale) {
                    this.getResults();
                }
		    },
		},
		created() {
        },
		beforeDestroy() {
			this.deinitData();
		},
		beforeRouteLeave (to, from, next) {
			this.deinitData();
    		next();
		},
		mounted() {
			console.log("mounted");
			this.initData();
		},

		methods: {
			deinitData() {
				if(this.event == "thread") {
					window.Echo.leave('patient.' + this.$root.user.id);
				}
			},
			toggleFilter(filter) {
				this.$router.push({path: "/" + this.event + "-list"});
				this.quickFilters[filter] = !this.quickFilters[filter];
				this.getResults();
			},
			// @updatehere
			initData() {
				this.setLoading(true);
				this.items = {};
				this.errors = [];

				if(this.event == "thread") {
					this.$set(this.quickFilters, 'assigned', false);
					this.$set(this.quickFilters, 'unassigned', false);
					this.$set(this.quickFilters, 'mine', false);
					this.$set(this.quickFilters, 'closed', false);
					//this.quickFilters["assigned"] = false;

					window.Echo.private('patient.' + this.$root.user.id)
						.listen('NewPatientThread', (e) => {
							this.addNotification({type: "success", content: this.autobrand('translations.new_request')});
							this.getResults();
						});
                    this.listenWithChunking('patient.' + this.$root.user.id, 'UpdatePatientThread', (e) => {
                        this.addNotification({type: "success", content: this.autobrand('translations.request_updated')});
                        var found = false;
                        for(var index in this.items.data) {
                            if(this.items.data[index].id == e.thread.id) {
                                found = true;
                                for (var attrname in e.thread) {
                                    console.log("Setting " + this.items.data[index][attrname] + " to " + e.thread[attrname]);
                                    this.items.data[index][attrname] = e.thread[attrname];
                                }
                            }
                        }
                        if(!found) {
                            // Can't push it on to the array like in the provider interface as this is still paginated.
                            this.getResults();
                        }
                    });
				}
				else {
					this.quickFilters = {};
				}
				axios.get(this.route + '/relatedData').then((res) => {
					for(var key in res.data) {
						this[key] = res.data[key];
					}
					this.initFilters();
					this.getResults(1);
				}).catch(error => {
					this.setLoading(false);
                    this.handleError(error, "load");
				});
			},
			// @updatehere
			initFilters() {
				this.setLoading(true);
				axios.get(this.route + '/getFilters').then((res) => {
					this.$refs.listFilter.filterFields = res.data;
					this.$refs.listFilter.clearFilters(null);
				});

			},
			// @updatehere
			getResults(page, event, prevent) {
                if(!this.appActive()) {
                    this.stale = true;
                    return Promise.reject("Application is not active. Data set to 'stale'. Will update when active.");
                }
				//this.setLoading(true);

				if (typeof page !== 'undefined') {
					this.items.current_page = page;
				}

				var search = (this.$refs && this.$refs.listFilter ? this.$refs.listFilter.$refs.search.value : "");

				var filter = encodeURIComponent(JSON.stringify(this.quickFilters));

				if(this.$refs && this.$refs.listFilter && this.$refs.listFilter.filterShown) {
					search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters));
				}
				axios.get(this.route + '?page=' + this.items.current_page + (this.archive ? '&archive=1' : '')).then((res) => {
				//axios.get(this.route + '?search=' + search + '&filter=' + filter + '&page=' + this.items.current_page).then((res) => {
					console.log("current_page: " + res.data.current_page);
					console.log("last_page: " + res.data.last_page);
					if(res.data.current_page > res.data.last_page && prevent !== true) {
						console.log("Re-searching with page in range.");
						this.items = {};
						this.getResults(res.data.last_page, undefined, true)
					}
					else {
						this.setLoading(false);
						this.items = res.data;
					}
				});

			},
			openView(event, id) {
				this.$router.push({path: "/" + this.event + '-show/' + id});
			},
			openCreate(event) {
				this.$router.push({path: "/" + this.event + '-create'});
			},
			debug() {
				console.log(this.items.data)
			},
			showFilter() {
				$(this.$refs.listFilter.$refs.modal).modal("show");
				setTimeout(function() {
					if (this.$refs.listFilter.filterShown) {
    					$(this.$refs.listFilter.$refs["filter-value-0"]).focus();
    				}
    				else {
    					$(this.$refs.listFilter.$refs.search).focus();
    				}
		        }.bind(this), 500);

			},
			canCreate() {
				if(this.event == "thread") {
					return false;
				}
				return false;
			},
            getItemCount() {
                if(this.items && this.items.data && this.items.total) {
                    return "[" + this.items.total + "]";
                    //return "--";
                }
                return "";
            },
            enableArchive() {
                this.$root.checkArchive(this.$root.user, () => {
                    this.archive = true;
                    this.getResults();
                });

                
            }
            
		}
    }
</script>
